//#region Dependencias
import React, { Component } from 'react';
import {
    BreadCumb,
    DataTables,
    NavBar,
    TimeOut,
    MRPAssistantModal
} from "../../components";
import config from "../../config";
import moment from "moment";
import {
    DISPATCH_ID,
    SERVICE_RESPONSE
} from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import { connect } from "react-redux";
import $ from "jquery";
import { Forecast, ForecastTimeInterval, MRPAssistant } from '../../components/NewOrder';
const CryptoJS = require("crypto-js");
//#endregion

//#region Variables globales
const apiClient = ApiClient.getInstance();
const dateFormat = (date) => {
    const dateFormatted = moment(date);
    if (dateFormatted.isValid()) { return dateFormatted.format("DD/MM/YYYY"); }
    return "--/--/----";
}
const typeView = (view) => {
    switch (view) {
        case "M": return "Mensual";
        case "W": return "Semanal";
        case "D": return "Diario";
        default: return "Mensual";
    }
}

const getMonth = (value) => {
    switch (value) {
        case "01": return "ENERO";
        case "02": return "FEBRERO";
        case "03": return "MARZO";
        case "04": return "ABRIL";
        case "05": return "MAYO";
        case "06": return "JUNIO";
        case "07": return "JULIO";
        case "08": return "AGOSTO";
        case "09": return "SEPTIEMBRE";
        case "10": return "OCTUBRE";
        case "11": return "NOVIEMBRE";
        case "12": return "DICIEMBRE";
        default: return "";
    }
}

const intervalName = (date = moment(), viewType = "M", multiYear = false) => {
    if (viewType === "M") { return `${getMonth(date.format("MM"))}${multiYear ? date.format(" YYYY") : ""}`; }
    else if (viewType === "W") { return `${date.isoWeek()}${multiYear ? date.format("/YYYY") : ""}`; }
    else if (viewType === "D") { return moment(date).format(multiYear ? "DD/MM/YYYY" : "DD/MM"); }
}
//#endregion

//#region Componente
class MRPAssistantView extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props)
        this.view = "mrpAssistant";
        this.headersDataTable = [
            { title: "Nombre del escenario", value: true, field: "MsnCode", format: null, classes: "text-left" },
            { title: "Descripción", value: true, field: "Descr", format: null, classes: "text-left" },
            { title: "Fecha de inicio", value: true, field: "StartDate", format: dateFormat, classes: "text-center" },
            { title: "Fecha final", value: true, field: "EndDate", format: dateFormat, classes: "text-center" },
            { title: "Actualizado", value: true, field: "UpdateDate", format: dateFormat, classes: "text-center" },
            { title: "Actualizado por", value: true, field: "UpdateBy", format: null, classes: "text-left" },
            { title: "Ultima ejecución", value: true, field: "LastExecDa", format: dateFormat, classes: "text-center" },
        ];
        this.state = {
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
            assistantModel: new MRPAssistant(),
            forecastList: [],
            action: 1,
            groupsItemData: [],
        }

        this.MRPModal = null;
    }

    async componentDidMount() {
        let date = {
            dateInit: moment().startOf("month").format("YYYYMMDD"),
            dateFinal: moment().endOf("month").format("YYYYMMDD"),
        }
        await this.getDocumentsList(date);
        await this.getDataLists();
    }
    //#endregion

    //#region ################# CRUD #################

    //#region Acciones generales
    updateModel = async (assistantModel) => {
        await this.setState({ assistantModel });
    }

    saveScnario = async (assistantModel, resposne) => {
        assistantModel.AbsEntry = resposne.AbsEntry;
        assistantModel.DocEntry = resposne.AbsEntry;
        assistantModel.MsnCode = resposne.MsnCode;
        assistantModel.ForecastArray = resposne.ForecastArray;
        await this.setState({ assistantModel });
    }

    getDataLists = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        const mrpCatalogs = await apiClient.getMRPCatalogs({catalogs: { forecast: true }});
        if (mrpCatalogs.status) {
            const forecastList = mrpCatalogs.data.forecast || [];

            await this.setState({ forecastList });
        }

        enableSpinner(false);
    }

    getTimeInterval = (startDate = moment(), endDate = moment(), viewType = "M", multiYear = false) => {
        let timeInterval = [];

        while (startDate.isBefore(endDate)) {
            timeInterval.push({
                Name: intervalName(startDate, viewType, multiYear),
                Date: startDate.format("YYYY-MM-DD"),
                Initial: 0,
                InitialOrg: 0,
                InStock: 0,
                OutStock: 0,
                Final: 0,
                FinalOrg: 0,
                Requests: 0,
            });

            if (viewType === "M") { startDate.add(1, "months"); }
            else if (viewType === "W") { startDate.add(7, "days"); }
            else if (viewType === "D") { startDate.add(1, "days"); }
        }

        return timeInterval;
    }
    //#endregion
    recordScenario = async model=>{
        const {enableSpinner, notificationReducer: { showAlert }} = this.props

        enableSpinner(true)
        let response = await apiClient.recordScenario(model);

        enableSpinner(false)

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({type:'success', message: response.message || 'CREADO'})
            await this.openDocumentDetails(response.data.AbsEntry);
        } else {
            showAlert({type:'error', message: response.message || 'ERROR'})
        }
    }
    //#region Crear nuevo documento
    createDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { assistantModel } = this.state;

        try {
            enableSpinner(true);

            let data = {
                table: "OFCT",
                model: assistantModel,
            };

            let responseArray = [];
            let response = await apiClient.createMRPDocument(data);

            try {
                responseArray.push({
                    billing: response.data ? response.data.docNumBilling : '',
                    docNum: response.data ? response.data.DocNum : '',
                    message: response.message ? response.message : '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    billing: '',
                    message: '',
                });
            }

            this.setState({ billingResponseArray: responseArray })

            $("#billingResponseModal").modal("show");
            $("#billingResponseModal").on("hidden.bs.modal", () => { this.setState({ billingResponseArray: null }) });

            if (response.status === 1) { $('#mrpAssistantModal').modal('hide'); }
            enableSpinner(false);
        } catch (e) {
            showAlert({ type: "error", message: JSON.stringify(e) });
            enableSpinner(false);
        }
    }

    createNewDocumentModel = async () => {
        const { enableSpinner } = this.props;
        enableSpinner(true)
        let whsArray = await apiClient.getSuggestionCatalogs({whs: true});
        let groupsItemData = await apiClient.getGroupsItemData();
        enableSpinner(false)
        whsArray = whsArray.status ? whsArray.data.warehouses || [] : [];
        groupsItemData = groupsItemData.status ? groupsItemData.data.GrupoArticulo || [] : [];
        
        for (let whs of whsArray) {
            whs.ReqSel = "Y";
            whs.InvtSel = "Y";
            whs.ExtIvntSel = "Y";
        }

        let assistantModel = new MRPAssistant();
        //MRP V2--LONGITUD 37 DIAS
        assistantModel.StartDate = moment().format('YYYY-MM-DD')
        assistantModel.EndDate = moment().add(37,'day').format('YYYY-MM-DD')
        assistantModel.HorizonLength = moment(assistantModel.EndDate,'YYYY-MM-DD').diff(moment(assistantModel.StartDate,'YYYY-MM-DD'),'day')
        assistantModel.PeriodsLen = 1
        assistantModel.GrpPeriods = 'D'
        //END MRP V2
        assistantModel.WhsArray = whsArray || [];

        await this.setState({ assistantModel, groupsItemData, action: 1 });
        $("#mrpAssistantModal").modal("show");
    }
    //#endregion

    //#region Consultar Información
    getDocumentsList = async (filters = {}) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        // Filtros de búsqueda de las previsiones
        let data = {
            table: "OMSN",
            filters: {
                dateStart: filters.dateInit || moment().format("YYYY-MM-DD"),
                dateEnd: filters.dateFinal || moment().format("YYYY-MM-DD"),
            }
        };

        enableSpinner(true);
        let docsListResponse = await apiClient.MRPDocumentsList(data);
        enableSpinner(false);

        if (docsListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            docsListResponse = docsListResponse.data || [];
            if (docsListResponse.length === 0) {
                this.setState({ data: [] });
                return showAlert({ type: 'info', message: "No se encontraron resultados correspondientes a la búsqueda.", timeOut: 5000 });
            }

            this.setState({ data: docsListResponse });
        } else {
            this.setState({ data: [] });
            showAlert({ type: 'info', message: `Ocurrio un error al consultar la información. ${docsListResponse}`, timeOut: 5000 });
        }
    };

    openDocumentDetails = async (DocEntry) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        // Filtros de búsqueda de las previsiones
        let data = {
            table: "OMSN",
            DocEntry
        };

        enableSpinner(true);
        let assistantResponse = await apiClient.MRPDocumentDetails(data);
        let whsArray = await apiClient.getSuggestionCatalogs({whs: true});
        let groupsItemData = await apiClient.getGroupsItemData();
        groupsItemData = groupsItemData.status ? groupsItemData.data.GrupoArticulo || [] : [];
        assistantResponse = assistantResponse.data;
        enableSpinner(false);

        let assistantModel = new MRPAssistant();
        const startDate = moment(assistantResponse.StartDate);
        const endDate = moment(assistantResponse.EndDate);
        const multiYear = endDate.year() > startDate.year();

        assistantModel.AbsEntry = assistantResponse.AbsEntry;
        assistantModel.AllItems = assistantResponse.AllItems;
        assistantModel.ByCompany = assistantResponse.ByCompany;
        assistantModel.Descr = assistantResponse.Descr;
        assistantModel.DisSelItem = assistantResponse.DisSelItem;
        assistantModel.DocEntry = assistantResponse.DocEntry;
        assistantModel.EndDate = endDate.format("YYYY-MM-DD");
        assistantModel.ExistStock = assistantResponse.ExistStock;
        assistantModel.ExpandedPO = assistantResponse.ExpandedPO;
        assistantModel.ExpandedSO = assistantResponse.ExpandedSO;
        assistantModel.ExpdPAgree = assistantResponse.ExpdPAgree;
        assistantModel.ExpdPQuota = assistantResponse.ExpdPQuota;
        assistantModel.ExpdPurReq = assistantResponse.ExpdPurReq;
        assistantModel.ExpdResINV = assistantResponse.ExpdResINV;
        assistantModel.ExpdSAgree = assistantResponse.ExpdSAgree;
        assistantModel.ExpdSQuota = assistantResponse.ExpdSQuota;
        assistantModel.ExpdTraReq = assistantResponse.ExpdTraReq;
        assistantModel.ExpdWOR = assistantResponse.ExpdWOR;
        assistantModel.FCTAbs = assistantResponse.FCTAbs;
        assistantModel.GrpPeriods = assistantResponse.GrpPeriods;
        assistantModel.HorizonLength = endDate.diff(startDate, assistantResponse.GrpPeriods === "M" ? "months" : assistantResponse.GrpPeriods === "W" ? "weeks" : "days") + 1;
        assistantModel.HldaysProd = assistantResponse.HldaysProd;
        assistantModel.HldaysPurc = assistantResponse.HldaysPurc;
        assistantModel.IgnoreCLT = assistantResponse.IgnoreCLT;
        assistantModel.IncHisData = assistantResponse.IncHisData;
        assistantModel.InvtLevel = assistantResponse.InvtLevel;
        assistantModel.ItmArray = assistantResponse.Items;
        assistantModel.ItmFrom = assistantResponse.ItmFrom;
        assistantModel.ItmGrp = assistantResponse.ItmGrp;
        assistantModel.ItmQryGrp = assistantResponse.ItmQryGrp;
        assistantModel.ItmReq = assistantResponse.ItmReq;
        assistantModel.ItmTo = assistantResponse.ItmTo;
        assistantModel.MaxLdTime = assistantResponse.MaxLdTime;
        assistantModel.MinStckLvl = assistantResponse.MinStckLvl;
        assistantModel.MsnCode = assistantResponse.MsnCode;
        assistantModel.OnlyNettbl = assistantResponse.OnlyNettbl;
        assistantModel.PeriodsLen = assistantResponse.PeriodsLen;
        assistantModel.PurchOAT = assistantResponse.PurchOAT;
        assistantModel.PurchOrder = assistantResponse.PurchOrder;
        assistantModel.PurchQuota = assistantResponse.PurchQuota;
        assistantModel.PurchReq = assistantResponse.PurchReq;
        assistantModel.RCMDefWhs = assistantResponse.RCMDefWhs;
        assistantModel.RcmCalDate = assistantResponse.RcmCalDate;
        assistantModel.RcmCalTime = assistantResponse.RcmCalTime;
        assistantModel.RcmLines = assistantResponse.Quotations;
        assistantModel.RcmPO = assistantResponse.RcmPO;
        assistantModel.RcmWO = assistantResponse.RcmWO;
        assistantModel.RcmWTRQ = assistantResponse.RcmWTRQ;
        assistantModel.ResInv = assistantResponse.ResInv;
        assistantModel.Rots = assistantResponse.Rots;
        assistantModel.SalesOAT = assistantResponse.SalesOAT;
        assistantModel.SalesOrder = assistantResponse.SalesOrder;
        assistantModel.SalesQuota = assistantResponse.SalesQuota;
        assistantModel.Simulation = assistantResponse.Simulation;
        assistantModel.SortBy = assistantResponse.SortBy;
        assistantModel.StartDate = startDate.format("YYYY-MM-DD");
        assistantModel.UpdateBy = assistantResponse.UpdateBy;
        assistantModel.UpdateDate = assistantResponse.UpdateDate;
        assistantModel.WhsArray = [];
        assistantModel.WorkOrder = assistantResponse.WorkOrder;
        assistantModel.Wtrq = assistantResponse.Wtrq;
        assistantModel.TimeInterval = [];

        //V2
        assistantModel.itmsGrpCod = assistantResponse.ItmGrp;
        assistantModel.ForecastArray = assistantResponse.ForecastArray || [];

        if (whsArray.status) {
            whsArray = whsArray.status ? whsArray.data.warehouses || [] : [];
            for (const whs of whsArray) {
                const whsFind = (assistantResponse.WhsArray || []).find(cWhs => cWhs.WhsCode === whs.WhsCode);
                if (whsFind) {
                    if (whsFind.ExtIvntSel === "N") { assistantModel.WhsChecks.ExtIvntSel = false; }
                    if (whsFind.InvtSel === "N") { assistantModel.WhsChecks.InvtSel = false; }
                    if (whsFind.ReqSel === "N") { assistantModel.WhsChecks.ReqSel = false; }
                    assistantModel.WhsArray.push(whsFind);
                }
                else {
                    let allDisabled = assistantResponse.WhsArray.length || assistantResponse.OnlyNettbl === "N";
                    if (allDisabled && (assistantModel.WhsChecks.ExtIvntSel || assistantModel.WhsChecks.InvtSel || assistantModel.WhsChecks.ReqSel)) {
                        assistantModel.WhsChecks = {
                            ReqSel: false,
                            InvtSel: false,
                            ExtIvntSel: false,
                        };
                    }
                    assistantModel.WhsArray.push({
                        WhsCode: whs.WhsCode,
                        WhsName: whs.WhsName,
                        ReqSel: allDisabled ? "N" : "Y",
                        InvtSel: allDisabled ? "N" : "Y",
                        ExtIvntSel: allDisabled ? "N" : "Y",
                    });
                }
            }
        }
        assistantModel.Documents = assistantResponse.Documents || [];

        let Lines = [];
        for (const resultLine of assistantResponse.Lines) {
            const startDateLine = moment(resultLine.StartDate);
            const period = Number(resultLine.PeriodID);
            let periodName = "";
            switch (period) {
                case -1000: periodName = "Datos Hitoricos"; break;
                case -1: periodName = "Datos Pasados"; break;
                case -2: periodName = "Datos Futuros"; break;
                default: periodName = intervalName(startDateLine, assistantModel.GrpPeriods, multiYear); break;
            }

            const existGeneralPeriod = assistantModel.TimeInterval.find(({ Name }) => Name === periodName);
            if (!existGeneralPeriod && period !== -2) {
                assistantModel.TimeInterval.push({
                    Name: periodName,
                    PeriodID: period < 0 ? period : Number(startDateLine.format("YYYYMMDD")),
                });
            }

            let existLine = Lines.find(({ ItemCode }) => ItemCode === resultLine.ItemCode);
            if (!existLine) {
                let line = {
                    ItemCode: resultLine.ItemCode,
                    ItemName: resultLine.ItemName,
                    TotalRequest: Number(resultLine.Requests || 0),
                    Details: false,
                    TimeInterval: [
                        {
                            Name: periodName,
                            Initial: Number(resultLine.Initial || 0),
                            InitialOrg: Number(resultLine.InitialOrg || 0),
                            InStock: Number(resultLine.InStock || 0),
                            Final: Number(resultLine.Final || 0),
                            FinalOrg: Number(resultLine.FinalOrg || 0),

                            OutStock: resultLine.StockType === "I" ? Number(resultLine.OutStock || 0) : 0,
                            Requests: resultLine.StockType === "R" ? Number(resultLine.Requests || 0) : 0,
                            Quotations: 0,
                        }
                    ],
                }

                Lines.push(line);
            } else {
                existLine.TotalRequest += Number(resultLine.Requests || 0);

                let timeInterval = existLine.TimeInterval.find(({ Name }) => Name === periodName);
                if (!timeInterval) {
                    existLine.TimeInterval.push({
                        Name: periodName,
                        Initial: Number(resultLine.Initial || 0),
                        InitialOrg: Number(resultLine.InitialOrg || 0),
                        InStock: Number(resultLine.InStock || 0),
                        Final: Number(resultLine.Final || 0),
                        FinalOrg: Number(resultLine.FinalOrg || 0),

                        OutStock: resultLine.StockType === "I" ? Number(resultLine.OutStock || 0) : 0,
                        Requests: resultLine.StockType === "R" ? Number(resultLine.Requests || 0) : 0,
                        Quotations: 0,
                    });
                } else {
                    if (resultLine.StockType === "I") { timeInterval.OutStock += Number(resultLine.OutStock || 0); }
                    else { timeInterval.Requests += Number(resultLine.Requests || 0); }
                    timeInterval.Final = Number(resultLine.Final || 0);
                }
            }
        }
        Lines = Lines.filter(({ TotalRequest }) => TotalRequest > 0);
        for (const resultLine of assistantResponse.Quotations) {
            const startDateLine = moment(resultLine.StartDate);
            const period = Number(resultLine.PeriodID);
            let periodName = "";
            switch (period) {
                case -1000: periodName = "Datos Hitoricos"; break;
                case -1: periodName = "Datos Pasados"; break;
                case -2: periodName = "Datos Futuros"; break;
                default: periodName = intervalName(startDateLine, assistantModel.GrpPeriods, multiYear); break;
            }

            const existGeneralPeriod = assistantModel.TimeInterval.find(({ Name }) => Name === periodName);

            if (!existGeneralPeriod && period !== -2) {
                assistantModel.TimeInterval.push({
                    Name: periodName,
                    PeriodID: period < 0 ? period : Number(startDateLine.format("YYYYMMDD")),
                });
            }

            let existLine = Lines.find(({ ItemCode }) => ItemCode === resultLine.ItemCode);
            if (existLine) {
                let timeInterval = existLine.TimeInterval.find(({ Name }) => Name === periodName);
                if (!timeInterval) {
                    existLine.TimeInterval.push({
                        Name: periodName,
                        Initial: 0,
                        InitialOrg: 0,
                        InStock: 0,
                        OutStock: 0,
                        Final: 0,
                        FinalOrg: 0,
                        Requests: 0,
                        Quotations: Number(resultLine.Quantity || 0),
                    });
                } else {
                    timeInterval.Quotations += Number(resultLine.Quantity || 0);
                }
            }
        }

        assistantModel.TimeInterval = assistantModel.TimeInterval.sort((a, b) => a.PeriodID - b.PeriodID);
        assistantModel.TimeInterval.push({ Name: "Datos Futuros" });
        assistantModel.Lines = Lines;

        await this.setState({ assistantModel, groupsItemData, action: 2 });
        await this.MRPModal.setState({ editMode: false });
        $("#mrpAssistantModal").modal("show");
    }
    //#endregion

    //#region Actualizar documento
    updateDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { assistantModel } = this.state;

        try {
        } catch (e) {
            showAlert({ type: "error", message: JSON.stringify(e) });
            enableSpinner(false);
        }

        return false;
    }
    //#endregion

    //#endregion ########### CRUD - END ##############

    //#region Render
    render() {
        const {
            _user,
            action,
            data,
            assistantModel,
            billingResponseArray,
            forecastList,
            groupsItemData,
        } = this.state;

        const {
            enableSpinner,
            notificationReducer: { showAlert }
        } = this.props;

        const actions = {
            openDocumentDetails: this.openDocumentDetails,
            createDocument: this.createNewDocumentModel,
        }

        let itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        let bytes = CryptoJS.AES.decrypt(itemsDashboard, 'exchange');
        itemsDashboard = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        let writeAccess = true;
        for (const key in itemsDashboard) { if (Object.hasOwnProperty.call(itemsDashboard, key)) { if (key === this.view) { writeAccess = itemsDashboard[key].Wr } } }

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'ASISTENTE MRP'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1 text-muted">ASISTENTE MRP </h2>
                    <MRPAssistantModal
                        ref={(ref) => { this.MRPModal = ref; }}
                        action={action}
                        writeAccess={writeAccess}
                        model={assistantModel}
                        groupsItemData={groupsItemData}
                        updateModel={this.updateModel}
                        saveScnario={this.saveScnario}

                        forecastList={forecastList}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        createScenario={this.recordScenario} />
                    <DataTables
                        headers={this.headersDataTable}
                        view={this.view}
                        data={data}
                        search={this.getDocumentsList}
                        actions={actions}
                        billingResponse={billingResponseArray} />
                </div>
            </div>
        );
    }
    //#endregion
}
//#endregion

//#region REDUX
const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};
//#endregion

export default connect(mapStateToProps, mapDispatchToProps)(MRPAssistantView); // Exportar componente